import { signOut as out } from 'aws-amplify/auth'
export async function signOut (): Promise<void> {
	try {
		await out()
	} catch (error) { /* empty */ }
}
